module.exports = __webpack_public_path__ + "static/img/王燕雄董事长.5cb8c006.png";